import { render, staticRenderFns } from "./Section1.vue?vue&type=template&id=4f04cd83&scoped=true&"
import script from "./Section1.vue?vue&type=script&lang=js&"
export * from "./Section1.vue?vue&type=script&lang=js&"
import style0 from "./Section1.vue?vue&type=style&index=0&id=4f04cd83&lang=scss&scoped=true&"
import style1 from "./Section1.vue?vue&type=style&index=1&id=4f04cd83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f04cd83",
  null
  
)

export default component.exports